import React from "react";
import "./PrivacyPolicy.css"; // ✅ reuse same styles

const Disclaimer = () => {
  return (
    <div className="policy-container">
      <div className="policy-card shadow-lg">
        <h2 className="policy-title text-center mb-3">
          Disclaimer
        </h2>

        <div className="underline"></div>

        <p>
          The website <strong>eSevaLinks</strong> is an independent platform and is 
          <strong> NOT an official Government website</strong>.
        </p>

        <h5>1. Information Purpose Only</h5>
        <p>
          We provide information and links related to government schemes and services 
          only for awareness and public convenience. Users are strongly advised to verify 
          all information from the respective official government portals.
        </p>

        <h5>2. No Government Affiliation</h5>
        <p>
          eSevaLinks does not represent any government organization, department, or authority. 
          All logos, scheme names, and references belong to their respective owners.
        </p>

        <h5>3. External Links</h5>
        <p>
          Our website may contain links directing users to official government websites. 
          We are not responsible for the content, privacy policy, or security of those external sites.
        </p>

        <h5>4. No Responsibility</h5>
        <p>
          eSevaLinks will not be responsible for any loss, misunderstanding, or issues faced 
          by users while accessing or applying on third-party or government portals.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
